import PowerBIEmbed from "../PowerBIEmbed";

const NILPage = () => {
  return (
    <div style={{ background: "white", minWidth: "100%", minHeight: "100%" }}>
      <PowerBIEmbed />
    </div>
  );
};

export default NILPage;
